export default "__VITE_ASSET__Dn1tKEtP__"